export default "__VITE_ASSET__C$acUlBg__"